import axios from "axios";
import { SERVER_URL } from "Constants";
import { processingStatus } from "Models/Enums";
import moment from "moment";
import { PaginatedResponse } from "Types/PaginatedResponse";
import { AxiosConfigFactory } from "Util/AxiosUtil";
import { MotorVehicleSearchRequest } from "Views/Components/SearchRequests/MotorVehicleSearchTypes";
import { SortingParams } from "./shared";

export type SearchRequestListItem = {
	id: string;
	date: Date;
	billTo: string;
	searchCriteria: string;
	productName: string;
	status: processingStatus;
	price: number;
	generatedBy: string;
	reportId?: string;
}

type GetSearchRequestsArgs = SortingParams & {
	searchBy?: string;
	businessEntityIds: string[],
	page?: number;
	dateRange?: Date[];
	noPagination?: boolean;
};

export async function getSearchRequests({
	searchBy,
	sortBy,
	sortDescending,
	businessEntityIds,
	page,
	dateRange,
	noPagination = false,
}: GetSearchRequestsArgs) {
	const url = `${SERVER_URL}/api/search/motor-vehicle/list`;
	const pageSize = noPagination ? 0 : 10;

	const formatDate = (date?: Date) => (date ? moment(date).format("YYYY-MM-DD") : undefined);

	const queryParams = {
		search: searchBy,
		startDate: formatDate(dateRange?.[0]),
		endDate: formatDate(dateRange?.[1] || dateRange?.[0]),
		orderBy: sortBy,
		descending: sortDescending,
		pageNo: page,
		pageSize,
		businessEntityIds: businessEntityIds?.length ? businessEntityIds : undefined
	};

	const requestConfig = AxiosConfigFactory.createRequestConfig(queryParams);
	return await axios.get<PaginatedResponse<SearchRequestListItem>>(url, requestConfig);
}

export type CreateSearchRequestBody = {
	businessId: string;
	searchDetail: MotorVehicleSearchRequest;
	servicePriceId: string;
}

export async function createSearchRequest(requestBody: CreateSearchRequestBody) {
	const url = `${SERVER_URL}/api/search/motor-vehicle/create`;
	return await axios.post<{ searchRequestId: string, message: string }>(url, requestBody);
}